// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function AppTourTooltip(props) {
  const {
    backProps,
    closeProps,
    index,
    isLastStep,
    primaryProps,
    skipProps,
    step,
    size,
    tooltipProps,
  } = props;
  const { t } = useTranslation('common');
  const { buttons, content, styles, title } = step;
  const showFooter = buttons.some(
    (button) => button === 'back' || button === 'primary' || button === 'skip',
  );
  const {
    color: closeColor,
    height: closeHeight,
    width: closeWidth,
    ...closeButtonStyle
  } = styles.buttonClose || {};

  const primaryColor = styles?.buttonNext?.backgroundColor || '#c2cc00';
  const inactiveColor = alpha(styles?.tooltip?.color || '#ffffff', 0.22);

  return (
    <div
      key="JoyrideTooltip"
      className="react-joyride__tooltip"
      data-joyride-step={index}
      {...(step.id && { 'data-joyride-id': step.id })}
      style={styles.tooltip}
      {...tooltipProps}
      aria-describedby="joyride-tooltip-content"
      {...(title ? { 'aria-labelledby': 'joyride-tooltip-title' } : {})}
    >
      {buttons.includes('close') && (
        <button type="button" style={closeButtonStyle} {...closeProps}>
          <svg
            height={
              typeof closeHeight === 'number' ? `${closeHeight}px` : closeHeight
            }
            preserveAspectRatio="xMidYMid"
            version="1.1"
            viewBox="0 0 18 18"
            width={
              typeof closeWidth === 'number' ? `${closeWidth}px` : closeWidth
            }
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z"
                fill={closeColor}
              />
            </g>
          </svg>
        </button>
      )}

      <div style={styles.tooltipContainer}>
        {title && (
          <h4 id="joyride-tooltip-title" style={styles.tooltipTitle}>
            {title}
          </h4>
        )}

        <div id="joyride-tooltip-content" style={styles.tooltipContent}>
          {content}
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${Math.max(size, 1)}, minmax(0, 1fr))`,
          gap: 6,
          marginBottom: showFooter ? 10 : 0,
          margin: 12,
        }}
        aria-hidden
      >
        {Array.from({ length: size }).map((_, stepIndex) => {
          const isActive = stepIndex <= index;

          return (
            <span
              key={stepIndex}
              style={{
                height: 8,
                borderRadius: 99,
                display: 'block',
                backgroundColor: isActive ? primaryColor : inactiveColor,
              }}
            />
          );
        })}
      </div>

      {showFooter && (
        <div style={styles.tooltipFooter}>
          <div style={{ ...styles.tooltipFooterSpacer, minWidth: 0 }}>
            {buttons.includes('skip') && !isLastStep && (
              <button type="button" style={styles.buttonSkip} {...skipProps}>
                {skipProps.title}
              </button>
            )}
          </div>

          {buttons.includes('back') && index > 0 && (
            <Button size="small" variant="text" {...backProps}>
              {t('actions.back')}
            </Button>
          )}
          {buttons.includes('primary') && (
            <Button
              size="small"
              disableElevation
              variant="contained"
              {...primaryProps}
            >
              {isLastStep ? t('actions.done') : t('actions.next')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
